import { ChangeDetectionStrategy, Component, computed, ContentChild, HostListener, Input, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { LocationSequence } from '@entscheidungsnavi/tools';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HierarchyMovementDirective } from '../hierarchy/movement.directive';
import { HierarchyNodeStateDirective } from '../hierarchy/node-state.directive';
import { HierarchyInterfaceDirective } from '../hierarchy/interface.directive';
import { HierarchyComponent } from '../hierarchy/hierarchy.component';

@Component({
  selector: 'dt-hierarchy-toolbar',
  templateUrl: './hierachy-toolbar.component.html',
  styleUrls: ['./hierachy-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDividerModule, MatTooltipModule],
})
export class HierarchyToolbarComponent {
  readonly focused = this.hierarchyNodeState.focused.asReadonly();
  readonly canGroup = computed(() => LocationSequence.canGroup(this.focused()));
  readonly canDelete = computed(() => this.focused().every(node => !node.isRoot()));

  @Input() showToolbarContextMenu = true;

  @ContentChild('nodeToolbar') toolbarTemplate: TemplateRef<{ $implicit: LocationSequence[] }>;

  constructor(
    protected hierarchy: HierarchyComponent<unknown>,
    protected hierarchyMovement: HierarchyMovementDirective<unknown>,
    protected hierarchyNodeState: HierarchyNodeStateDirective<unknown>,
    protected hierarchyInterface: HierarchyInterfaceDirective<unknown>,
  ) {}

  @HostListener('mousedown', ['$event'])
  onClick(event: MouseEvent) {
    // Prevent clicks within the toolbar from deselecting elements
    event.stopPropagation();
  }
}
